import { createAppConfig } from '@yozu-devops/vite-app-configurer'

const appConfig = createAppConfig({
  REACT_APP_ACCOUNT_MANAGEMENT_SERVER: `${process.env.REACT_APP_ACCOUNT_MANAGEMENT_SERVER}`,
  REACT_APP_HAZCULATOR_SERVER: `${process.env.REACT_APP_HAZCULATOR_SERVER}`,
  REACT_APP_KEYCLOAK_SERVER: `${process.env.REACT_APP_KEYCLOAK_SERVER}`,
  REACT_APP_KEYCLOAK_REALM: `${process.env.REACT_APP_KEYCLOAK_REALM}`,
  REACT_APP_KEYCLOAK_CLIENT_ID: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`,
  REACT_APP_STRIPE_API_KEY: `${process.env.REACT_APP_STRIPE_API_KEY}`
})

export default appConfig
